import React from 'react';
import { connect } from 'react-redux'
import {
    IonRefresher,
    IonRefresherContent,
    withIonLifeCycle,
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonList,
    IonContent,
    IonHeader, IonPage, IonTitle, IonToolbar,
    IonIcon,
    IonLabel,
    IonButton,
    IonPopover,
    IonButtons,
    IonMenuButton, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
    IonBackButton,
    IonBadge,
    IonSearchbar,
    IonDatetime,
    IonFabButton,
    IonFooter,
    IonModal,
    IonText,
    IonCheckbox,
    IonLoading,
    IonToast,
    IonAlert,
    IonAccordionGroup,
    IonAccordion
} from '@ionic/react';
import { ticketOutline, trashOutline, ellipsisVerticalOutline, serverOutline, cart, checkmarkCircle, closeCircle, cubeOutline, createOutline, cash, calendar, barcode, search, funnel, add, closeOutline, checkmarkOutline, eye, person } from 'ionicons/icons';
import MenuPrincipal from '../../components/menu/MenuPrincipal';
import { getLoginApp, getToken, getPermissions, getNewLogin, getEnabledModules } from '../../utils/functions';
import { initdb } from "../../data_base_local/dataservice";
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import UtilActions from '../../actions/UtilActions';
import PurchaseActions from '../../actions/PurchaseActions';
import PosActions from '../../actions/PosActions';
import Select from 'react-select'
import {
    queryAllLocations,
    createLocationTest,
    queryAllPermisions,
    queryAllConfiguration,
    createConfiguration,
    getConfigurationById,
    updateConfigurationById,
    createPermission,
    createActivitie
} from "../../data_base_local/dataservice";
import Moment from 'react-moment';
import { DebounceInput } from 'react-debounce-input';
const options2: any = { style: 'currency', currency: 'USD', useGrouping: false };
const _numberFormat = new Intl.NumberFormat('en-US', options2);

interface IProps {
    post_: any;
    get_: any;
    validate_permission_: any;
    get_default: any;
    get_data_module: any;
    setData_: any;
}

interface IState {
    data_default: any;
    ModalShow: any;
    fields: any;
    datalogin: any;
    pages: any;
    pageSize: any;
    total_rows: any;
    searchText: any;
    current_count_data: any;
    alertDestroy: any;
    dataDB: any;
    data_pagin_DB: any;

    isOpenTransactionDate: any;
    isOpenDateStart: any;
    isOpenDateEnd: any;
    DateStart: any;
    DateEnd: any;
    isOpenModalFilterDate: any;
    formErrors: any;
    data_module: any;
    list_search_products: any;
    ModalListShow: any;
    products_added: any;

    simpleToast: any;
    response: any;
    loading: any;
    ModalViewShow: any;
    dataShow: any;
}

class Purchases extends React.Component<IProps, IState> {
    ionInfiniteScrollRefData: React.RefObject<HTMLIonInfiniteScrollElement>;
    ModalcreateEdit: React.RefObject<HTMLIonModalElement>;
    ModallistProduct: React.RefObject<HTMLIonModalElement>;
    ModalView: React.RefObject<HTMLIonModalElement>;
    constructor(props: any) {
        super(props)
        this.ModalView = React.createRef<HTMLIonModalElement>();
        this.ModalcreateEdit = React.createRef<HTMLIonModalElement>();
        this.ModallistProduct = React.createRef<HTMLIonModalElement>();
        this.ionInfiniteScrollRefData = React.createRef<HTMLIonInfiniteScrollElement>();
        this.state = {
            data_default: props.data_default,
            ModalShow: false,
            fields: {
                id: null,
                transaction_date: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
                location_id: null,
                contact_id: null,
                ref_no: '',
                discount_type: 'fixed',
                discount_amount: 0,
                tax_id: null,
                final_total: 0,
                total_before_tax: 0,

                is_contado: 1,
                tax_amount: 0,
                new_supplier: ''
            },
            datalogin: {},
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false,
            dataDB: [],
            data_pagin_DB: [],

            isOpenTransactionDate: false,
            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false,
            formErrors: {},
            data_module: {},
            list_search_products: [],
            ModalListShow: false,
            products_added: [],

            simpleToast: props.simpleToast,
            response: props.response,
            loading: props.loading,
            ModalViewShow: false,
            dataShow: {},
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({
            dataDB: nextProps.data.purchasesDB && nextProps.data.purchasesDB ? nextProps.data.purchasesDB : [],
            data_pagin_DB: nextProps.data.data_pagin_purchasesDB && nextProps.data.data_pagin_purchasesDB ? nextProps.data.data_pagin_purchasesDB : [],
            pages: nextProps.data.purchasesDB && nextProps.data.purchasesDB.pages ? nextProps.data.purchasesDB.pages : 0,
            total_rows: nextProps.data.purchasesDB && nextProps.data.purchasesDB.total_rows ? nextProps.data.purchasesDB.total_rows : 0,
            current_count_data: nextProps.data.data_pagin_purchasesDB ? nextProps.data.data_pagin_purchasesDB.length : 0,

            data_module: nextProps.data.data_module && nextProps.data.data_module ? nextProps.data.data_module : {},
            list_search_products: nextProps.data.list_search_products && nextProps.data.list_search_products ? nextProps.data.list_search_products : [],
            ModalListShow: nextProps.data.list_search_products && nextProps.data.list_search_products.length > 0 ? true : false,

            simpleToast: nextProps.data.simpleToast,
            response: nextProps.data.response,
            loading: nextProps.data.loading,
        });

        if (nextProps.data.view_active == "Purchases") {
            console.log("UNSAFE_componentWillReceiveProps Purchases", nextProps);

            if (nextProps.data.refresh_list) {
                this.setState({
                    pages: 0,
                    pageSize: 10,
                });

                setTimeout(this.getDataPaginInit.bind(this), 1000);
            }
            if (this.ionInfiniteScrollRefData.current) {
                if (nextProps.data.concat_list) {
                    this.ionInfiniteScrollRefData.current.complete();
                }
            }

        }

    }

    componentDidMount() {
        this.setState({
            ModalShow: false,
            ModalListShow: false,
            fields: {
                id: null,
                transaction_date: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
                location_id: null,
                contact_id: null,
                ref_no: '',
                discount_type: 'fixed',
                discount_amount: 0,
                tax_id: null,
                final_total: 0,
                total_before_tax: 0,
                is_contado: 1,
                tax_amount: 0,
                new_supplier: ''
            },
            dataShow: {},
            datalogin: getLoginApp(),
            pages: 0,
            pageSize: 10,
            total_rows: 0,
            searchText: '',
            current_count_data: 0,
            alertDestroy: false,

            isOpenDateStart: false,
            isOpenDateEnd: false,
            DateStart: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            DateEnd: moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            isOpenModalFilterDate: false,
            ModalViewShow: false,
        });

        this.props.get_default({
            typeOption: 'get_data_default',
            user_id: getLoginApp().id,
        }, "api/get_data_default");

        //traer datos para compras 
        this.props.get_data_module({
            typeOption: 'get_data_module',
            user_id: getLoginApp().id,
            filtros: [
                'slc_suppliers',
                'slc_tax_rates',
                'slc_business_locations'
            ]
        }, "api/get_data_module");

        setTimeout(this.getDataPaginInit.bind(this), 1000);
    }

    getDataPaginInit() {

        if (this.state.total_rows != 0 && this.state.current_count_data == this.state.total_rows && this.state.pages != 0) {
            if (this.ionInfiniteScrollRefData.current) {
                this.ionInfiniteScrollRefData.current.complete();
            }
            return;
        }

        this.props.get_({
            user_id: this.state.datalogin.id,
            typeOption: 'get_list_purchases',
            search: this.state.searchText,
            pageSize: this.state.pageSize,
            pages: this.state.pages,
            current_count_data: this.state.current_count_data,
            view_active: 'list_purchases',
            searchText: this.state.searchText,

            start: moment(this.state.DateStart, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
            end: moment(this.state.DateEnd, "YYYY-MM-DD hh:mm:ss+ZZ").format("YYYY-MM-DD"),
        }, "api/list_purchases");
    }

    render_data(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-6 size='6'>
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.ref_no}</strong></label> <br />
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={calendar} /> </strong> {row.transaction_date}</label> <br />
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={person} /> </strong> {row.contact && (row.contact.supplier_business_name ?? '') + " / " + (row.contact.name ?? '')}</label> <br />
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={cash} /></strong>
                            <strong> {_numberFormat.format(row.final_total).replace("$", '')}</strong>
                            {' '}
                            {row.payment_status == 'paid' ?
                                <IonBadge color={"success"} style={{ color: '#ffffff' }}> {'Pagada'}</IonBadge>
                                : row.payment_status == 'partial' ?
                                    <IonBadge color={"info"} style={{ color: '#ffffff' }}> {'Parcial'} </IonBadge>
                                    : <IonBadge color={"danger"} style={{ color: '#ffffff' }}>{'Crédito'}</IonBadge>
                            }
                        </label>
                    </IonCol>
                    <IonCol col-6 size='6'>
                        {
                            row.parent_name ? (
                                <label className='text-sm font-medium text-g60'><IonBadge color={"primary"}>{row.parent_name}</IonBadge></label>
                            ) : null
                        }
                        {
                            row.sub_parent_name ? (
                                <>
                                    <br /><label className='text-sm font-medium text-g60'> -- <IonBadge color={"rosado"}>{row.sub_parent_name}</IonBadge></label>
                                </>
                            ) : null
                        }
                    </IonCol>
                    <IonCol col-12 size='12' className='text-center'>
                        <IonButton size='small' color="celeste"
                            onClick={
                                e => this.setState({ ModalViewShow: true, dataShow: row })
                            }
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={eye} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>
                        <IonButton size='small'
                            onClick={
                                e => this.openModal(row)
                            }
                        >
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={createOutline} // Puedes cambiar 'add' por 'createOutline' si tienes ese icono
                                    size="small"
                                />
                            </div>
                        </IonButton>
                        <IonButton size='small' color={'danger'} onClick={
                            e => this.setState({ alertDestroy: true, fields: row })
                        }>
                            <div>
                                <IonIcon
                                    color="light"
                                    slot="icon-only"
                                    icon={trashOutline}
                                    size="small"
                                />
                            </div>
                        </IonButton>
                    </IonCol>
                </IonRow>
            </div >
        );
    }

    setSearchText(e: any) {
        const value = e.target.value;
        this.setState({
            searchText: value.toLowerCase(),
            pages: 0,
            pageSize: 10,
        });
        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    changeFilterDate(e: any) {

        let DateStart: any = null;
        let DateEnd: any = null;

        if (e.target.value == 'hoy') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'ayer') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(1, 'd').format("YYYY-MM-DD");
        } else if (e.target.value == 'ultimo_7') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").subtract(6, 'd').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD");
        } else if (e.target.value == 'este_mes') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('month').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('month').format("YYYY-MM-DD");
        } else if (e.target.value == 'este_ano') {
            DateStart = moment(new Date(), "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(new Date(), "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        } else if (e.target.value == 'ano_pasado') {
            DateStart = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").startOf('year').format("YYYY-MM-DD");
            DateEnd = moment(moment().year() - 1, "YYYY-MM-DD hh:mm").endOf('year').format("YYYY-MM-DD");
        }

        this.setState({
            isOpenDateStart: false,
            DateStart: DateStart,
            isOpenDateEnd: false,
            DateEnd: DateEnd,
            isOpenModalFilterDate: false,
            pages: 0,
            pageSize: 10,
        });

        setTimeout(this.getDataPaginInit.bind(this), 100);
    }

    openModal(row: any) {
        let fields = {
            id: row && row.id ? row.id : null,
            transaction_date: row && row.transaction_date ? moment(row.transaction_date, "DD-MM-YYYY hh:mm").format("YYYY-MM-DD") : moment(new Date(), "YYYY-MM-DD hh:mm").format("YYYY-MM-DD"),
            location_id: row && row.location_id ? row.location_id : null,
            contact_id: row && row.contact_id ? row.contact_id : null,
            ref_no: row && row.ref_no ? row.ref_no : null,
            discount_type: row && row.discount_type ? row.discount_type : 'fixed',
            discount_amount: row && row.discount_amount ? row.discount_amount : 0,
            tax_id: row && row.tax_id ? row.tax_id : null,
            tax_amount: row && row.tax_amount ? row.tax_amount : 0,
            final_total: row && row.final_total ? row.final_total : 0,
            total_before_tax: row && row.total_before_tax ? row.total_before_tax : 0,
            is_contado: row && row.is_contado ? row.is_contado : 1,
            new_supplier: ''
        };

        let products_added: any = [];
        if (row && row.purchase_lines && row.purchase_lines.length > 0) {
            row.purchase_lines.forEach((element: any) => {
                products_added.push({
                    "product_id": element.product_id,
                    "name": element.product.name,
                    "type": element.product.type,
                    "quantity": element.quantity,
                    "unit_id": element.product.unit_id,
                    "variation": element.variations.name,
                    "qty_available": 0,
                    "sub_sku": element.variations.sub_sku,
                    "default_sell_price": parseFloat(element.purchase_price_inc_tax) + ((parseFloat(element.purchase_price_inc_tax) * parseFloat(element.profit_percent) / 100)),
                    "purchase_line_id": element.id,

                    "pp_without_discount": element.purchase_price_inc_tax,
                    "purchase_price": element.purchase_price_inc_tax,
                    "purchase_price_inc_tax": element.purchase_price_inc_tax,
                    "variation_id": element.variation_id,

                });
            });
        }
        this.setState({
            ModalShow: true,
            fields: fields,
            formErrors: {},
            products_added: products_added
        });
    }

    dismissModal() {
        this.setState({
            ModalShow: false,
            fields: {
                id: null
            }
        });
    }

    SaveDataPost() {
        let fields = this.state.fields;
        fields.products = this.state.products_added;
        let error = false;
        let formErrors: any = {};
        //if (this.state.fields && (this.state.fields.final_total == "" || this.state.fields.final_total == null || this.state.fields.final_total == 0)) { formErrors['final_total'] = "*Campo Requerido y mayor a cero"; error = true };
        if (this.state.fields && (this.state.fields.location_id == "" || this.state.fields.location_id == null)) { formErrors['location_id'] = "*Campo Requerido"; error = true };


        if (this.state.fields && (this.state.fields.contact_id == "" || this.state.fields.contact_id == null)) {
            if (this.state.fields && (this.state.fields.new_supplier == "" || this.state.fields.new_supplier == null)) {
                formErrors['contact_id'] = "*Campo Requerido o nuevo proveedor"; error = true
            };
        };
        if (fields.products.length === 0) {
            formErrors['products'] = "*Agregar al menos un producto"; error = true;
        }
        if (error) {
            this.setState({
                formErrors: formErrors,
                list_search_products: [],
            });
        } else {

            if (fields.id) {
                this.props.post_({
                    typeOption: 'updateDataPurchase',
                    action: 'update',
                    user_id: this.state.datalogin.id,
                    fields: this.state.fields,
                    view_active: 'Purchases'
                }, "api/updateDataPurchase");
            } else {
                this.props.post_({
                    typeOption: 'saveDataPurchase',
                    action: 'create',
                    user_id: this.state.datalogin.id,
                    fields: this.state.fields,
                    view_active: 'Purchases'
                }, "api/saveDataPurchase");
            }
            this.setState({
                ModalShow: false,
                list_search_products: [],
                ModalListShow: false,
            });
        }
    }

    handleChangeFields(event: any) {
        console.log(event);
        let fields = this.state.fields;
        fields[event.target.name] = event.target.value;
        this.setState({ fields });
        setTimeout(this.refreshTotal.bind(this), 100);
    }

    handleFocus(event: any) {
        event.target.select();
    }

    render_data_car(row: any, key: any) {
        return (
            <div className='card_line' key={key}>
                <IonRow >
                    <IonCol col-10 size='10'>
                        <label className='text-sm font-medium text-g60'><strong>{row.name}</strong></label> <br />
                    </IonCol>
                    <IonCol col-2 size='2'>
                        <IonButton style={{ textAlign: "center", marginRight: '10px' }} size='small' color={'danger'} onClick={(e: any) => this.RemovedProductsCart(e, row)}>
                            <IonIcon icon={closeOutline}></IonIcon>
                        </IonButton>
                    </IonCol>
                    <IonCol col-12 size='12'>
                        <label className='text-sm font-medium text-g60'><strong><IonIcon className='icon-vertical-aling' size='small' icon={barcode} /> {row.sku}  STOCK ({_numberFormat.format(parseFloat(row.qty_available ?? 0)).replace("$", "")})</strong></label> <br />
                    </IonCol>
                    <IonCol col-4 size='4'>
                        Cant <br />
                        <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                            onChange={(e: any) => this.onchangeProductsAdded(e, key)}
                            defaultValue={_numberFormat.format(parseFloat(row.quantity)).replace("$", "")}
                            min="0" name="quantity" />
                    </IonCol>
                    <IonCol col-4 size='4'>
                        Costo <br />
                        <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                            onChange={(e: any) => this.onchangeProductsAdded(e, key)}
                            defaultValue={_numberFormat.format(parseFloat(row.purchase_price)).replace("$", "")}
                            min="0" name="purchase_price" />
                    </IonCol>
                    <IonCol col-4 size='4'>
                        P Venta <br />
                        <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                            defaultValue={_numberFormat.format(parseFloat(row.default_sell_price)).replace("$", "")}
                            min="0" name="default_sell_price" />
                    </IonCol>

                </IonRow>
            </div >
        );
    }

    getProducts(event: any) {
        let query = '';
        const target = event.target as HTMLIonSearchbarElement;
        console.log(target, target.value);
        if (target.value != '' && target.value != null) {

            let location_id = this.state.fields.location_id;
            if (location_id != null && (location_id != '')) {
                console.log(target.value, 'enviado');
                this.props.get_({
                    typeOption: 'get_search_products',
                    user_id: getLoginApp().id,
                    view_active: 'purchases',
                    search: target.value,
                    location_id: location_id
                }, "api/get_search_products");
            } else {
                this.props.setData_({ list_search_products: [], response: { success: 0, Msg: 'Seleccione una ubicación para buscar' }, simpleToast: true });
            }
        } else {
            console.log(target.value, 'no enviado');
            this.setState({
                list_search_products: [],
                ModalListShow: false
            });
        }
    }

    closemodallistProduct(e: any) {
        this.setState({
            ModalListShow: false,
            list_search_products: [],
        });
    }

    addProductsCart(e: any, row: any) {
        e.preventDefault();

        let product = {
            "product_id": row.product_id,
            "variation_id": row.id,
            "quantity": "1.00",
            "name": row.name,
            "product_unit_id": row.unit_id,
            "qty_available": row.qty_available,
            "sub_unit_id": row.unit_id,
            "pp_without_discount": row.dpp_inc_tax,
            "purchase_price": row.dpp_inc_tax,
            "purchase_price_inc_tax": row.dpp_inc_tax,
            "default_sell_price": row.default_sell_price,
            "sku": row.sub_sku,
        };

        this.setState((prevState) => ({
            products_added: [...prevState.products_added, product]
        }));
        setTimeout(this.refreshTotal.bind(this), 100);
    }

    onDidDismissToast(e: any) {
        this.props.setData_({ response: {}, simpleToast: false });
    }

    refreshTotal() {
        let fields = this.state.fields;
        let total = 0;
        this.state.products_added.forEach((element: any) => {
            total += parseFloat(element.purchase_price) * parseFloat(element.quantity);
        });


        if (fields.discount_amount != null && fields.discount_amount != '') {
            if (fields.discount_type == 'fixed') {
                total = total - parseFloat(fields.discount_amount);
            } else if (fields.discount_type == 'percentage') {
                total = total - (total * parseFloat(fields.discount_amount) / 100);
            }
        }

        fields['total_before_tax'] = total;

        if (fields.tax_id != null && fields.tax_id != '') {
            let tax_rate: any = this.state.data_module.slc_tax_rates.find((obj: any) => obj.id == fields.tax_id);
            if (tax_rate) {
                total = fields['total_before_tax'] + (fields['total_before_tax'] * parseFloat(tax_rate.amount) / 100);
                fields['tax_amount'] = (fields['total_before_tax'] * parseFloat(tax_rate.amount) / 100);
            }
        }

        fields['final_total'] = total;
        this.setState({ fields });

    }

    onchangeProductsAdded(e: any, key: any) {
        let products_added = this.state.products_added;
        products_added[key][e.target.name] = e.target.value;
        this.setState({ products_added }, () => {
            this.refreshTotal();
        });
    }

    SendDestroy() {
        this.props.post_({
            typeOption: 'destroyDatapurchase',
            action: 'destroy',
            user_id: this.state.datalogin.id,
            fields: this.state.fields,
            view_active: 'Purchases'
        }, "api/destroyDatapurchase");
        this.setState({
            alertDestroy: false
        });
    }

    RemovedProductsCart(e: any, row: any) {
        e.preventDefault();

        let products_added = this.state.products_added.filter((item: any) => item.product_id !== row.product_id || item.variation_id !== row.variation_id);

        this.setState((prevState) => ({
            products_added: products_added
        }));
        setTimeout(this.refreshTotal.bind(this), 100);
    }

    closemodalShow(e: any) {
        this.setState({
            ModalViewShow: false,
        });
    }
    render() {
        const { dataShow, ModalViewShow, alertDestroy, simpleToast, response, loading, products_added, ModalListShow, list_search_products, isOpenTransactionDate, formErrors, data_module, ModalShow, fields, searchText, data_pagin_DB, isOpenModalFilterDate, DateStart, isOpenDateStart, DateEnd, isOpenDateEnd } = this.state;
        let data_render_data = [];

        if (data_pagin_DB && data_pagin_DB.length > 0) {
            data_render_data = [];
            data_render_data = data_pagin_DB.map((val: any, key: any) =>
                this.render_data(val, key)
            );
        };

        let data_render_data_products_added = [];
        if (products_added && products_added.length > 0) {
            data_render_data_products_added = [];
            data_render_data_products_added = products_added.map((val: any, key: any) =>
                this.render_data_car(val, key)
            );
        };

        return (
            <>
                <IonAlert
                    backdropDismiss={false}
                    isOpen={alertDestroy}
                    header={'Confirmar'}
                    message={'¿Desea eliminar la compra?'}
                    buttons={[
                        {
                            text: 'Si',
                            handler: (e) => {
                                this.SendDestroy();
                            }
                        },
                        {
                            text: 'No',
                            handler: e => {
                                this.setState({
                                    alertDestroy: false
                                });
                            }
                        }
                    ]}
                />
                <IonLoading
                    //color="light"
                    cssClass='my-custom-class'
                    isOpen={!!(loading && loading.isOpen)}
                    message={`${loading && loading.Msg ? loading.Msg : ''}`}
                />
                {
                    response && response.Msg ? (
                        <IonToast
                            isOpen={!!simpleToast}
                            color={response && response.success == 1 ? 'success' : 'danger'}
                            position='top'
                            message={`${response && response.Msg ? response.Msg : ''}`}
                            duration={1500}
                            onDidDismiss={e => this.onDidDismissToast(e)}
                        />
                    ) : null
                }
                <IonPage id="main-content">
                    <IonHeader>
                        <IonToolbar color="primary">
                            <IonButtons slot="start">
                                <IonBackButton defaultHref="/home" text={""} />
                            </IonButtons>
                            <IonTitle style={{ fontSize: "15px" }}>COMPRAS</IonTitle>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent fullscreen scrollEvents={true} className='background'>
                        <IonRow>
                            <IonCol col-12 size='12' style={{ textAlign: "center", display: "none" }}>
                                <div style={{ display: "none" }}>
                                    <IonSearchbar onIonChange={e => this.setSearchText(e)} value={searchText}></IonSearchbar>
                                </div>
                            </IonCol>
                            <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                <IonButton
                                    expand="full"
                                    onClick={(e: any) => {
                                        e.persist();
                                        this.setState({
                                            isOpenDateStart: true,
                                            pages: 0,
                                            pageSize: 10,
                                        });
                                    }}
                                >
                                    Inicio :
                                    <Moment
                                        date={DateStart}
                                        format="DD-MM-YYYY"
                                    />
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenDateStart}
                                    onDidDismiss={() =>
                                        this.setState({
                                            isOpenDateStart: false,
                                            pages: 0,
                                            pageSize: 10,
                                        })}
                                >
                                    <IonDatetime
                                        presentation="date"
                                        value={moment(DateStart, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                        onIonChange={(e: any) => {
                                            this.setState({ DateStart: e.detail.value, isOpenDateEnd: false });
                                            setTimeout(this.getDataPaginInit.bind(this), 1000);
                                        }}
                                    ></IonDatetime>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-2 size='2' style={{ textAlign: "center" }}>
                                <IonButton color='primary' expand="full" onClick={(e: any) => {
                                    e.persist();
                                    this.setState({ isOpenModalFilterDate: true });
                                }}>
                                    <IonIcon icon={funnel}></IonIcon>
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenModalFilterDate}
                                    onDidDismiss={() =>
                                        this.setState({ isOpenModalFilterDate: false })}
                                >
                                    <IonList inset={true}>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'hoy' } })}
                                        >
                                            <IonLabel>Hoy</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ayer' } })}>
                                            <IonLabel>Ayer</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ultimo_7' } })}>
                                            <IonLabel>Los Ultimos 7 Dias</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_mes' } })}>
                                            <IonLabel>Este Mes</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'este_ano' } })}>
                                            <IonLabel>Este Año</IonLabel>
                                        </IonItem>
                                        <IonItem
                                            onClick={(e: any) => this.changeFilterDate({ target: { name: 'get_date', value: 'ano_pasado' } })}>
                                            <IonLabel>El Año Pasado</IonLabel>
                                        </IonItem>
                                    </IonList>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-5 size='5' style={{ textAlign: "center" }}>
                                <IonButton
                                    expand="full"
                                    onClick={(e: any) => {
                                        e.persist();
                                        this.setState({ isOpenDateEnd: true });
                                    }}
                                >
                                    Fin :
                                    <Moment
                                        date={DateEnd}
                                        format="DD-MM-YYYY"
                                    />
                                </IonButton>
                                <IonPopover
                                    isOpen={isOpenDateEnd}
                                    onDidDismiss={() =>
                                        this.setState({ isOpenDateEnd: false })}
                                >
                                    <IonDatetime
                                        presentation="date"
                                        value={moment(DateEnd, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                        onIonChange={(e: any) => {
                                            this.setState({ DateEnd: e.detail.value, isOpenDateEnd: false });
                                            setTimeout(this.getDataPaginInit.bind(this), 1000);
                                        }}

                                    ></IonDatetime>
                                </IonPopover>
                            </IonCol>
                            <IonCol col-12 size='12' class='divflex'>
                                <IonIcon icon={search} className='iconseach'></IonIcon>
                                <DebounceInput
                                    className='btn_search'
                                    placeholder={'Código'}
                                    minLength={2}
                                    debounceTimeout={2000}
                                    value={searchText}
                                    onChange={e => this.setSearchText(e)} />
                            </IonCol>
                            <IonCol size='12'>
                                {data_render_data}
                            </IonCol>
                        </IonRow>
                    </IonContent>
                    <IonModal onDidDismiss={this.dismissModal.bind(this)} isOpen={ModalShow} ref={this.ModalcreateEdit} trigger="open-modal">
                        <IonContent className="ion-padding">
                            <IonHeader>
                                <IonToolbar color="primary">
                                    <IonTitle>{fields && fields.id ? 'Editar Compras' : 'Nueva Compra'}</IonTitle>
                                    <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={this.dismissModal.bind(this)}>
                                        <IonIcon icon={closeOutline}></IonIcon>
                                    </IonButton>
                                </IonToolbar>
                            </IonHeader>
                            <IonRow>
                                <IonCol size='6' col-6>
                                    <label>Sucursal: </label>
                                    {
                                        data_module && data_module.slc_business_locations && data_module.slc_business_locations.length > 0 ?
                                            <Select
                                                onChange={(e: any) => this.handleChangeFields({ target: { name: 'location_id', value: e.value } })}
                                                placeholder="Ubicación"
                                                name='location_id'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={[
                                                    { label: 'Seleccione', value: null },
                                                    ...(data_module && data_module.slc_business_locations
                                                        .map((value: any) => ({ label: value.name, value: value.id }))
                                                    )
                                                ]}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={fields.location_id ?
                                                    data_module.slc_business_locations && data_module.slc_business_locations.length > 0 ?
                                                        { label: data_module.slc_business_locations.filter((item: any) => item.id == fields.location_id)[0].name, value: data_module.slc_business_locations.filter((item: any) => item.id == fields.location_id)[0].id }
                                                        : { label: 'Seleccione', value: null }
                                                    : { label: 'Seleccione', value: null }
                                                }
                                            /> : null
                                    }
                                    {formErrors && formErrors.location_id && (
                                        <IonText color="danger" className="ion-padding-start">
                                            <small>{formErrors.location_id}</small>
                                        </IonText>
                                    )}
                                </IonCol>
                                <IonCol size='6' col-6>
                                    <label>Proveedor: </label>
                                    {
                                        data_module && data_module.slc_suppliers && data_module.slc_suppliers.length > 0 ?
                                            <Select
                                                onChange={(e: any) => this.handleChangeFields({ target: { name: 'contact_id', value: e.value } })}
                                                placeholder="Proveedor"
                                                name='contact_id'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={[
                                                    { label: 'Seleccione', value: null },
                                                    ...(data_module && data_module.slc_suppliers
                                                        .map((value: any) => ({ label: value.name, value: value.id }))
                                                    )
                                                ]}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={fields.contact_id ?
                                                    data_module.slc_suppliers && data_module.slc_suppliers.length > 0 ?
                                                        { label: data_module.slc_suppliers.filter((item: any) => item.id == fields.contact_id)[0].name, value: data_module.slc_suppliers.filter((item: any) => item.id == fields.contact_id)[0].id }
                                                        : { label: 'Seleccione', value: null }
                                                    : { label: 'Seleccione', value: null }
                                                }
                                            /> : null
                                    }
                                    {formErrors && formErrors.contact_id && (
                                        <IonText color="danger" className="ion-padding-start">
                                            <small>{formErrors.contact_id}</small>
                                        </IonText>
                                    )}
                                </IonCol>
                                {
                                    fields && fields.id == null ?
                                        <>
                                            <IonCol col-12 size='12'>
                                                <IonAccordionGroup>
                                                    <IonAccordion value="first">
                                                        <IonItem slot="header" color="light">
                                                            <IonLabel><label style={{ fontWeight: 600 }}>Nuevo Proveedor</label></IonLabel>
                                                        </IonItem>
                                                        <div className="ion-padding" slot="content">
                                                            <div style={{ marginTop: 2 }}>
                                                                <IonCol size='12' col-12>
                                                                    <label>Nuevo Proveedor: </label>
                                                                    <input
                                                                        autoComplete="off"
                                                                        type="text"
                                                                        className='inputform style_input'
                                                                        defaultValue={fields && fields.new_supplier ? fields.new_supplier : ''}
                                                                        onChange={e => this.handleChangeFields({ target: { name: 'new_supplier', value: e.target.value } })}
                                                                        name="new_supplier" />
                                                                </IonCol>
                                                                <IonCol size='6' col-6>
                                                                    <label>Celular: </label>
                                                                    <input
                                                                        autoComplete="off"
                                                                        type="text"
                                                                        className='inputform style_input'
                                                                        defaultValue={fields && fields.mobile ? fields.mobile : ''}
                                                                        onChange={e => this.handleChangeFields({ target: { name: 'mobile', value: e.target.value } })}
                                                                        name="mobile" />
                                                                </IonCol>
                                                            </div>
                                                        </div>
                                                    </IonAccordion>
                                                </IonAccordionGroup>
                                            </IonCol>
                                        </> : null
                                }

                                <IonCol size='12' col-12>
                                    <IonButton
                                        expand="full"
                                        onClick={(e: any) => {
                                            e.persist();
                                            this.setState({ isOpenTransactionDate: true });
                                        }}
                                    >
                                        Fecha de Compra :
                                        <Moment
                                            date={fields && fields.transaction_date}
                                            format="DD-MM-YYYY"
                                        />
                                    </IonButton>
                                    <IonPopover
                                        isOpen={isOpenTransactionDate}
                                        onDidDismiss={() => this.setState({ isOpenTransactionDate: false })}
                                    >
                                        <IonDatetime
                                            presentation="date"
                                            value={moment(fields && fields.transaction_date, "YYYY-MM-DD hh:mm").format("YYYY-MM-DD")}
                                            onIonChange={(e: any) => {
                                                this.setState({ isOpenTransactionDate: false });
                                                let date_selected = e.detail.value;
                                                this.handleChangeFields({ target: { name: 'transaction_date', value: date_selected } });
                                            }}

                                        ></IonDatetime>
                                    </IonPopover>
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <label>No Factura: </label>
                                    <input
                                        autoComplete="off"
                                        type="text"
                                        className='inputform style_input'
                                        defaultValue={fields && fields.ref_no ? fields.ref_no : ''}
                                        onChange={e => this.handleChangeFields({ target: { name: 'ref_no', value: e.target.value } })}
                                        name="ref_no" />
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    <strong>Productos: {products_added.length}</strong>
                                </IonCol>
                                <IonCol col-12 size='12'>
                                    <IonSearchbar debounce={1000} onIonInput={(event: any) => this.getProducts(event)}></IonSearchbar>
                                    {data_render_data_products_added}
                                    {formErrors && formErrors.products && (
                                        <IonText color="danger" className="ion-padding-start">
                                            <small>{formErrors.products}</small>
                                        </IonText>
                                    )}
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    Tipo de descuento <br />
                                    {
                                        <Select
                                            onChange={(e: any) => this.handleChangeFields({ target: { name: 'discount_type', value: e.value } })}
                                            placeholder="Tipo de descuento"
                                            name='discount_type'
                                            menuPortalTarget={document.querySelector('body')}
                                            isSearchable={false}
                                            options={[
                                                { label: "Fijo", value: 'fixed' },
                                                { label: "Porcentaje", value: 'percentage' },
                                            ]}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                            }}
                                            defaultValue={fields && fields.discount_type ?
                                                fields.discount_type == 'fixed' ? { label: "Fijo", value: 'fixed' } : { label: "Porcentaje", value: 'percentage' }
                                                :
                                                { label: "Fijo", value: 'fixed' }
                                            }
                                        />
                                    }
                                </IonCol>
                                <IonCol col-6 size='6'>
                                    Monto del Descuento <br />
                                    <input autoComplete="off" onFocus={this.handleFocus} type="number" className='input_quantity style_input'
                                        value={_numberFormat.format(fields && fields.discount_amount ? parseFloat(fields.discount_amount) : 0).replace("$", "")} onChange={e => this.handleChangeFields(e)} name="discount_amount" />
                                </IonCol>
                                <IonCol size='12' col-12>
                                    <label>Impuesto: </label>
                                    {
                                        data_module && data_module.slc_tax_rates && data_module.slc_tax_rates.length > 0 ?
                                            <Select
                                                onChange={(e: any) => this.handleChangeFields({ target: { name: 'tax_id', value: e.value } })}
                                                placeholder="Ubicación"
                                                name='tax_id'
                                                menuPortalTarget={document.querySelector('body')}
                                                isSearchable={false}
                                                options={[
                                                    { label: 'Seleccione', value: null },
                                                    ...(data_module && data_module.slc_tax_rates
                                                        .map((value: any) => ({ label: value.name, value: value.id }))
                                                    )
                                                ]}
                                                styles={{
                                                    menu: provided => ({ ...provided, zIndex: 9999, color: 'black' }),
                                                }}
                                                defaultValue={fields.tax_id ?
                                                    data_module.slc_tax_rates && data_module.slc_tax_rates.length > 0 ?
                                                        { label: data_module.slc_tax_rates.filter((item: any) => item.id == fields.tax_id)[0].name, value: data_module.slc_tax_rates.filter((item: any) => item.id == fields.tax_id)[0].id }
                                                        : { label: 'Seleccione', value: null }
                                                    : { label: 'Seleccione', value: null }
                                                }
                                            /> : null
                                    }
                                    {formErrors && formErrors.tax_id && (
                                        <IonText color="danger" className="ion-padding-start">
                                            <small>{formErrors.tax_id}</small>
                                        </IonText>
                                    )}
                                </IonCol>

                                {
                                    fields && fields.id == null ?
                                        <>
                                            <IonCol col-6 size='6'>
                                                <IonCheckbox onIonChange={e => this.handleChangeFields({ target: { name: 'is_contado', value: 1 } })} checked={fields && fields.is_contado && fields.is_contado == 1 ? true : false} labelPlacement="start" alignment="center">
                                                    Contado
                                                </IonCheckbox>
                                            </IonCol>
                                            <IonCol col-6 size='6'>
                                                <IonCheckbox onIonChange={e => this.handleChangeFields({ target: { name: 'is_contado', value: 2 } })} checked={fields && fields.is_contado && fields.is_contado == 2 ? true : false} labelPlacement="start" alignment="center">
                                                    Crédito
                                                </IonCheckbox>
                                            </IonCol>
                                        </> : null
                                }


                                <IonCol col-12 size='12'>
                                    {(() => {
                                        const subtotal = fields && fields.total_before_tax ? parseFloat(fields.total_before_tax) : 0;
                                        const taxAmount = fields && fields.tax_amount ? parseFloat(fields.tax_amount) : 0;
                                        const finalTotal = subtotal + taxAmount;
                                        return (
                                            <IonGrid>
                                                <IonRow>
                                                    <IonCol size="8">Subtotal</IonCol>
                                                    <IonCol size="4" style={{ textAlign: 'right' }}>{_numberFormat.format(subtotal).replace("$", "")}</IonCol>
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol size="8">Impuesto</IonCol>
                                                    <IonCol size="4" style={{ textAlign: 'right' }}>{_numberFormat.format(taxAmount).replace("$", "")}</IonCol>
                                                </IonRow>
                                                <IonRow>
                                                    <IonCol size="8"><strong>Total Neto</strong></IonCol>
                                                    <IonCol size="4" style={{ textAlign: 'right' }}><strong>{_numberFormat.format(finalTotal).replace("$", "")}</strong></IonCol>
                                                </IonRow>
                                            </IonGrid>
                                        );
                                    })()}
                                </IonCol>

                            </IonRow>
                        </IonContent>
                        <IonFooter collapse="fade" className='footerfixed'>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton color="dark" onClick={() => this.dismissModal()}>
                                        Cancel
                                    </IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton color="primary" strong={true} onClick={() => this.SaveDataPost()}>
                                        Guardar
                                    </IonButton>
                                </IonButtons>
                            </IonToolbar>
                        </IonFooter>
                    </IonModal>
                    <IonModal onWillDismiss={e => this.closemodallistProduct(e)} isOpen={ModalListShow} trigger="open-modal">
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle>Lista de Productos (<strong>Agregados: {products_added.length}</strong>)</IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(e) => this.closemodallistProduct(e)}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            {
                                /*
    [
        {
            "product_id": 134,
            "name": "Bath & Body splash",
            "type": "single",
            "quantity": 1,
            "current_price": "740.0000",
            "current_price_discount": "740.0000",
            "discount_amount": 0,
            "discount_type": "fixed",
            "sell_allow_overselling": 0,
            "enable_stock": 1,
            "unit_id": 1,
            "product_image": "",
            "id": 134,
            "variation": "DUMMY",
            "qty_available": "94.0000",
            "default_sell_price": "740.0000",
            "sub_sku": "0007B",
            "dpp_inc_tax": "281.5300",
            "sub_units": [
                {
                    "id": 1,
                    "name": "Und",
                    "multiplier": 1,
                    "_price": 0,
                    "_price_group": 0,
                    "price_groups_all": [],
                    "allow_decimal": 0
                }
            ]
        }
    ]
                                */
                            }
                            <IonRow>
                                <IonCol size='12'>
                                    {
                                        list_search_products && list_search_products.length > 0 ?
                                            list_search_products.map((row: any, key: any) =>
                                                <div className='card_line' key={key}>
                                                    <IonRow >
                                                        <IonCol col-8 size='8'>
                                                            <label className='text-sm font-medium text-g60'><strong>{row.name}</strong></label> <br />
                                                            <label className='text-sm font-medium text-g60'>SKU: {row.sub_sku}</label> <br />
                                                            <label className='text-sm font-medium text-g60'>Precio: {_numberFormat.format(row.default_sell_price)}</label> <br />
                                                        </IonCol>
                                                        <IonCol col-4 size='4' className='text-center'>
                                                            <IonButton size='small' color={'primary'} onClick={(e) => this.addProductsCart(e, row)}>
                                                                <IonIcon icon={checkmarkOutline}></IonIcon>
                                                            </IonButton>
                                                        </IonCol>
                                                    </IonRow>
                                                </div>
                                            )
                                            :
                                            <div className='card_line'>
                                                <IonRow>
                                                    <IonCol size='12'>
                                                        <label className='text-sm font-medium text-g60'>No hay productos disponibles</label>
                                                    </IonCol>
                                                </IonRow>
                                            </div>
                                    }
                                </IonCol>
                            </IonRow>
                        </IonContent>
                    </IonModal>
                    <IonModal onWillDismiss={e => this.closemodalShow(e)} isOpen={ModalViewShow} trigger="open-modal">
                        <IonHeader>
                            <IonToolbar>
                                <IonTitle> <strong>Compra: {dataShow ? dataShow.ref_no : ''}</strong> </IonTitle>
                                <IonButton slot="end" style={{ textAling: "center", marginRight: '10px' }} onClick={(e) => this.closemodalShow(e)}>
                                    <IonIcon icon={closeOutline}></IonIcon>
                                </IonButton>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            <IonRow>
                                <IonCol size='12'>
                                    {
                                        dataShow && dataShow.contact ?
                                            <>
                                                <IonGrid>
                                                    <IonRow>
                                                        <IonCol size='12'>
                                                            <strong>Fecha de Compra:</strong>
                                                            <label>
                                                                {dataShow.transaction_date ?
                                                                    dataShow.transaction_date
                                                                    : ''}
                                                            </label>
                                                        </IonCol>
                                                        <IonCol size='12'>
                                                            <strong>Proveedor:</strong>
                                                            <label>{dataShow.contact.name}</label>
                                                        </IonCol>
                                                    </IonRow>
                                                    <IonRow>
                                                    </IonRow>
                                                </IonGrid>
                                            </>
                                            :
                                            null
                                    }
                                </IonCol>
                                <IonCol size='12'>
                                    <IonGrid>
                                        <IonRow className='ion-align-items-center' style={{ backgroundColor: 'var(--ion-color-primary)', color: '#ffffff', fontWeight: 'bold' }}>
                                            <IonCol size='6'>Producto</IonCol>
                                            <IonCol size='2' className='text-center'>Cant.</IonCol>
                                            <IonCol size='2' className='text-right'>Precio</IonCol>
                                            <IonCol size='2' className='text-right'>Total</IonCol>
                                        </IonRow>
                                    </IonGrid>
                                    {
                                        dataShow && dataShow.purchase_lines && dataShow.purchase_lines.length > 0 ?
                                            dataShow.purchase_lines.map((row: any, key: any) =>
                                                <IonGrid key={key}>
                                                    <IonRow className='ion-align-items-center'>
                                                        <IonCol size='6'>
                                                            {row.product.name} {row.product.type == "variable" ? row.variations.name : ""} <b />

                                                            {row.variation ? row.variation.sub_sku : row.product.sub_sku}
                                                        </IonCol>
                                                        <IonCol size='2' className='text-center'>
                                                            {row.quantity}
                                                        </IonCol>
                                                        <IonCol size='2' className='text-right'>
                                                            {_numberFormat.format(row.purchase_price_inc_tax).replace("$", "")}
                                                        </IonCol>
                                                        <IonCol size='2' className='text-right'>
                                                            {_numberFormat.format(row.quantity * row.purchase_price).replace("$", "")}
                                                        </IonCol>
                                                    </IonRow>
                                                </IonGrid>
                                            )
                                            :
                                            null
                                    }
                                </IonCol>
                                <IonCol size='12'>
                                    <IonGrid>
                                        <IonRow>
                                            {(() => {
                                                const subtotal = dataShow && dataShow.total_before_tax
                                                    ? parseFloat(dataShow.total_before_tax)
                                                    : (dataShow && dataShow.purchase_lines
                                                        ? dataShow.purchase_lines.reduce((acc: number, r: any) => {
                                                            const qty = parseFloat(r.quantity || 0);
                                                            const price = parseFloat(r.purchase_price || 0);
                                                            return acc + qty * price;
                                                        }, 0)
                                                        : 0);

                                                const taxAmount = dataShow && dataShow.tax_amount ? parseFloat(dataShow.tax_amount) : 0;
                                                const finalTotal = dataShow && dataShow.final_total ? parseFloat(dataShow.final_total) : subtotal + taxAmount;

                                                return (
                                                    <div style={{ width: '100%', overflowX: 'auto' }}>
                                                        <table style={{ width: '100%', borderCollapse: 'collapse', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', borderRadius: 4, overflow: 'hidden' }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ padding: '10px 12px', borderTop: '1px solid #eee' }}><strong>Subtotal</strong></td>
                                                                    <td style={{ padding: '10px 12px', textAlign: 'right', borderTop: '1px solid #eee' }}><strong>{_numberFormat.format(subtotal).replace("$", "")}</strong></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ padding: '10px 12px' }}><strong>Impuesto</strong></td>
                                                                    <td style={{ padding: '10px 12px', textAlign: 'right' }}><strong>{_numberFormat.format(taxAmount).replace("$", "")}</strong></td>
                                                                </tr>
                                                                <tr style={{ backgroundColor: '#fafafa' }}>
                                                                    <td style={{ padding: '12px 12px', fontWeight: 700 }}><strong>Total</strong></td>
                                                                    <td style={{ padding: '12px 12px', textAlign: 'right', fontWeight: 700 }}><strong>{_numberFormat.format(finalTotal).replace("$", "")}</strong></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                );
                                            })()}
                                        </IonRow>
                                    </IonGrid>

                                </IonCol>
                            </IonRow>
                        </IonContent>
                    </IonModal>
                    <div
                        style={{
                            position: 'fixed',
                            bottom: '16px',
                            right: '16px',
                        }}
                    >
                        <IonFabButton onClick={(e) => this.openModal(e)} color="primary">
                            <IonIcon icon={add}></IonIcon>
                        </IonFabButton>
                    </div>
                </IonPage >
            </>
        );
    };
}

const mapStateToProps = (state: any) => {
    return {
        data: state.data
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        get_: (fields: any, controller: string) => dispatch(PurchaseActions.get_(fields, controller)),
        post_: (data: any, controller: string) => dispatch(PurchaseActions.post_(data, controller)),
        validate_permission_: () => dispatch(UtilActions.validate_permission_()),
        get_default: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
        get_data_module: (fields: any, controller: string) => dispatch(UtilActions.get_(fields, controller)),

        setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),


    }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps)(Purchases));
